import {TelephonyCall} from './types';

/** A call is live until the backend reports `ended`; the outcome is irrelevant for liveness. */
export const isTelephonyCallLive = (call: TelephonyCall) => call.status !== 'ended';
